@if (products().length > 0) {
  <h2>{{ data().headline }}</h2>

  @if (data().options.enabled) {
    <ui-product-slider
      [duration]="data().options.duration"
      [navigation]="data().options.navigation"
      [autoplay]="data().options.autoplay"
      [products]="products()"
      [highlightedProducts]="highlightedProducts()"
      (addToShoppingList)="dialog.openDialogWithProduct($event.item, $event.quantity)"
    ></ui-product-slider>
  } @else {
    <div [class]="cardViewClass()">
      @for (product of products(); track product.sku) {
        <ui-product-card
          [product]="product"
          [isPromotion]="highlightedProducts().includes(product)"
          (addToShoppingListClicked)="dialog.openDialogWithProduct($event.item, $event.quantity)"
          [showActions]="true"
          uiProductImpression
          [position]="$index"
        ></ui-product-card>
      }
    </div>
  }

  <ui-add-to-shopping-list-dialog #dialog>
  </ui-add-to-shopping-list-dialog>
}
